exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-contentful-page-slug-tsx": () => import("./../../../src/pages/{ContentfulPage.slug}.tsx" /* webpackChunkName: "component---src-pages-contentful-page-slug-tsx" */)
}

